import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { InferType } from "yup";
import { merchantDeliveryChargeTemplateValidationForm } from "../../utils/validationSchemas";
import MerchantEditForm from "./MerchantEditForm";
import UserProfile from "./UserProfile";

const EditMerchant = (props: any) => {
  const {
    profile,
    isLoading,
    handleEdit,
    openAddReceiverPopup,
    setOpenAddReceiverPopup,
    openAddSenderPopup,
    setOpenAddSenderPopup,
  } = props;

  const editMethods = useForm<
    InferType<typeof merchantDeliveryChargeTemplateValidationForm>
  >({
    resolver: yupResolver(merchantDeliveryChargeTemplateValidationForm),
    defaultValues: {
      delivery_charge_template: profile?.delivery_charge_template,
      vat_pan: profile?.vat_pan,
      default_sender: profile?.default_sender,
      default_receiver: profile?.default_receiver,
      default_payment_method: profile?.default_payment_method,
      default_product_type: profile?.default_product_type,
      default_service_type: profile?.default_service_type,
      charge_type: profile?.charge_type,
      code: profile?.code,
      charge: profile?.charge,
      company_name: profile?.company_name,
      short_code: profile?.short_code,
      exim_code: profile?.exim_code,
      product_type: profile?.product_type?.map(
        (item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })
      ),
      service_type: profile?.service_type?.map(
        (item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })
      ),
      service_city: profile?.service_city?.map(
        (item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })
      ),
      service_branch: profile?.service_branch?.map(
        (item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })
      ),
      payment_method: profile?.payment_method?.map(
        (item: Record<string, string>) => ({
          label: item?.name,
          value: item?.id,
        })
      ),
      st_charge: profile?.st_charge ?? null,
    },
  });

  return (
    <>
      <UserProfile profile={profile} />
      <FormProvider {...editMethods}>
        <MerchantEditForm
          isLoading={isLoading}
          handleEdit={handleEdit}
          openAddReceiverPopup={openAddReceiverPopup}
          setOpenAddReceiverPopup={setOpenAddReceiverPopup}
          openAddSenderPopup={openAddSenderPopup}
          setOpenAddSenderPopup={setOpenAddSenderPopup}
          profile={profile}
        />
      </FormProvider>
    </>
  );
};

export default EditMerchant;
